import { InputContainer } from './style';
import ArrowDown from '../../assets/arrow-down.svg';

export function SelectData(props) {
  return (
    <InputContainer width={props.width}>
      <p>{props.label}</p>
      <span onClick={props.onClick}>
        {props.value} <img src={ArrowDown} alt="" />
      </span>
    </InputContainer>
  )
}